<template>
    <div class="dropdown card-context-menu" ref="dropdown">
        <button
            class="btn btn-sm btn-ellipsis"
            type="button"
            @click.stop="toggleDropdown"
            :aria-expanded="isOpen"
            aria-haspopup="true"
        >
            <!-- Horizontal Ellipsis Unicode Character -->
            <span>&#x2026;</span>
        </button>
        <div
            class="dropdown-menu dropdown-menu-right"
            :class="{ show: isOpen }"
            @click="onMenuItemClick"
        >
            <!-- Slot for dropdown menu items -->
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardContextMenu',
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        onMenuItemClick() {
            // Close the menu when any item inside the dropdown menu is clicked
            this.isOpen = false;
        },
        handleClickOutside(event) {
            if (
                this.isOpen &&
                this.$refs.dropdown &&
                !this.$refs.dropdown.contains(event.target)
            ) {
                this.isOpen = false;
            }
        },
    },
};
</script>
